import { Component, OnInit, ViewChild } from '@angular/core';
import { IgxToggleDirective, OverlaySettings } from '@infragistics/igniteui-angular';

@Component({
  selector: 'app-wait-indicator',
  templateUrl: './wait-indicator.component.html',
  styleUrl: './wait-indicator.component.scss'
})
export class WaitIndicatorComponent implements OnInit {

  @ViewChild('waitIndicator', { static: true, read: IgxToggleDirective })
  public waitIndicator!: IgxToggleDirective;

  public open = false;

  private settings: OverlaySettings = {
    closeOnEscape: false,
    closeOnOutsideClick: false
  };

  public show = (): void => this.waitIndicator.open(this.settings);

  public hide = (): void => this.waitIndicator.close();

  ngOnInit(): void {
    this.waitIndicator.opened.subscribe(e => this.open = true);
    this.waitIndicator.closed.subscribe(e => this.open = false);
  }
}
